/* GENERATED by tools/dc-port from design-reference/PointFive OS Original.dc.html — DOM-faithful view.
 * Do not hand-edit layout/style literals; regenerate with `pnpm --filter @pointfive/dc-port port`. */
import { Fragment } from 'react';
import * as dc from '@/lib/dc';
import { Toggle } from '@pointfive/ui';
import type { ViewModel } from './view-model';

export function CopyTradingView({ m }: { m: ViewModel }) {
  return (
    <div
      style={{
        maxWidth: '1040px',
        margin: '0 auto',
        padding: '24px 12px 40px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      {' '}
      {m.cpDisconnected ? (
        <>
          {' '}
          <div
            style={{
              background: 'var(--surface)',
              border: '1px solid var(--card-line)',
              boxShadow: 'var(--shadow-card)',
              borderRadius: '16px',
              padding: '40px 24px',
              textAlign: 'center',
            }}
          >
            {' '}
            <i className="ph ph-copy" style={{ fontSize: '30px', color: 'var(--ghost)' }}></i>{' '}
            <div style={{ fontSize: '13.5px', fontWeight: '500', marginTop: '12px' }}>
              Copy trading is not connected
            </div>{' '}
            <div
              style={{
                fontSize: '11.5px',
                color: 'var(--muted)',
                marginTop: '5px',
                lineHeight: '1.6',
                maxWidth: '420px',
                marginLeft: 'auto',
                marginRight: 'auto',
              }}
            >
              Link a CopyFactory subscriber account to mirror provider trades into Exness #184745. Your Risk
              Rules still apply to every copied entry.
            </div>{' '}
            <button
              className="scp-6842c79"
              onClick={m.cpConnect}
              title="Connect CopyFactory"
              aria-label="Connect CopyFactory"
              style={{
                marginTop: '16px',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '7px',
                fontSize: '12px',
                fontWeight: '500',
                padding: '9px 18px',
                borderRadius: '99px',
                border: '1px solid color-mix(in srgb, var(--pos) 55%, transparent)',
                background: 'color-mix(in srgb, var(--pos) 10%, transparent)',
                color: 'var(--pos)',
                cursor: 'pointer',
              }}
            >
              <i className="ph ph-plugs-connected" style={{ fontSize: '14px' }}></i>Connect CopyFactory
            </button>{' '}
          </div>{' '}
        </>
      ) : null}{' '}
      {m.cpConnected ? (
        <>
          {' '}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {' '}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
              {' '}
              <div
                style={{
                  display: 'flex',
                  gap: '2px',
                  padding: '3px',
                  borderRadius: '99px',
                  border: '1px solid var(--l8)',
                }}
              >
                {' '}
                {(m.cpTabs ?? []).map((t, i56) => (
                  <Fragment key={i56}>
                    {' '}
                    <button
                      onClick={t?.go}
                      aria-label={dc.a(t?.label)}
                      style={dc.css(
                        `display:inline-flex;align-items:center;gap:6px;padding:4px 13px;border-radius:99px;border:none;background:${dc.s(t?.bg)};color:${dc.s(t?.fg)};font-weight:${dc.s(t?.fw)};font-size:10.5px;cursor:pointer`,
                      )}
                    >
                      {dc.t(t?.label)}
                      <span
                        style={{ fontSize: '9.5px', opacity: '0.75', fontVariantNumeric: 'tabular-nums' }}
                      >
                        {dc.t(t?.count)}
                      </span>
                    </button>{' '}
                  </Fragment>
                ))}{' '}
              </div>{' '}
              <div style={{ flex: '1' }}></div>{' '}
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: '10.5px',
                  padding: '4px 11px',
                  borderRadius: '99px',
                  border: '1px solid color-mix(in srgb, var(--pos) 40%, transparent)',
                  color: 'var(--pos)',
                }}
              >
                <i className="ph ph-plugs-connected" style={{ fontSize: '11px' }}></i>CopyFactory · Exness
                #184745
              </span>{' '}
              <button
                className="scp-bd1be61"
                onClick={m.cpDisconnect}
                title="Disconnect CopyFactory"
                aria-label="Disconnect CopyFactory"
                style={{
                  fontSize: '10.5px',
                  padding: '4px 11px',
                  borderRadius: '99px',
                  border: '1px solid var(--l10)',
                  background: 'transparent',
                  color: 'var(--muted2)',
                  cursor: 'pointer',
                }}
              >
                Disconnect
              </button>{' '}
            </div>{' '}
            {m.cpIsProviders ? (
              <>
                {' '}
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit,minmax(400px,1fr))',
                    gap: '12px',
                  }}
                >
                  {' '}
                  {(m.cpProviders ?? []).map((p, i57) => (
                    <Fragment key={i57}>
                      {' '}
                      <div
                        style={{
                          background: 'var(--surface)',
                          border: '1px solid var(--card-line)',
                          boxShadow: 'var(--shadow-card)',
                          borderRadius: '16px',
                          padding: '16px 18px 14px',
                        }}
                      >
                        {' '}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          {' '}
                          <div style={{ flex: '1', minWidth: '0' }}>
                            <div style={{ fontSize: '13px', fontWeight: '500' }}>{dc.t(p?.name)}</div>
                            <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                              {dc.t(p?.style)}
                            </div>
                          </div>{' '}
                          <span
                            style={dc.css(
                              `font-size:9.5px;padding:2px 9px;border-radius:99px;border:1px solid var(--l10);color:${dc.s(p?.riskFg)}`,
                            )}
                          >
                            {dc.t(p?.risk)}
                          </span>{' '}
                          <button
                            onClick={p?.go}
                            title={dc.a(p?.btnLabel)}
                            aria-label={dc.a(p?.btnLabel)}
                            style={dc.css(
                              `font-size:11px;font-weight:500;padding:5px 14px;border-radius:99px;border:1px solid ${dc.s(p?.btnBd)};background:${dc.s(p?.btnBg)};color:${dc.s(p?.btnFg)};cursor:pointer`,
                            )}
                          >
                            {dc.t(p?.btnLabel)}
                          </button>{' '}
                        </div>{' '}
                        <div
                          style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            gap: '6px',
                            marginTop: '11px',
                          }}
                        >
                          {' '}
                          <span
                            style={{
                              fontSize: '9px',
                              letterSpacing: '0.11em',
                              textTransform: 'uppercase',
                              color: 'var(--muted2)',
                              fontWeight: '600',
                            }}
                          >
                            Trades
                          </span>{' '}
                          {(p?.stratChips ?? []).map((s, i58) => (
                            <Fragment key={i58}>
                              <span
                                style={dc.css(
                                  `font-size:10px;padding:3px 10px;border-radius:99px;border:1px solid ${dc.s(s?.bd)};color:${dc.s(s?.fg)}`,
                                )}
                              >
                                {dc.t(s?.label)}
                              </span>
                            </Fragment>
                          ))}{' '}
                        </div>{' '}
                        {p?.allBlocked ? (
                          <>
                            {' '}
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '7px',
                                marginTop: '8px',
                                fontSize: '10.5px',
                                color: 'var(--neg)',
                              }}
                            >
                              <i className="ph ph-warning-circle" style={{ fontSize: '12px' }}></i>
                              {dc.t(p?.blockedNote)}
                            </div>{' '}
                          </>
                        ) : null}{' '}
                        {p?.partlyBlocked ? (
                          <>
                            {' '}
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '7px',
                                marginTop: '8px',
                                fontSize: '10.5px',
                                color: 'var(--amb-2)',
                              }}
                            >
                              <i className="ph ph-funnel" style={{ fontSize: '12px' }}></i>
                              {dc.t(p?.blockedNote)}
                            </div>{' '}
                          </>
                        ) : null}{' '}
                        <div
                          style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(5,1fr)',
                            gap: '8px',
                            marginTop: '13px',
                          }}
                        >
                          {' '}
                          <div
                            style={{
                              border: '1px solid var(--l8)',
                              borderRadius: '11px',
                              padding: '9px 10px',
                            }}
                          >
                            <div
                              style={{
                                fontSize: '9px',
                                letterSpacing: '0.11em',
                                textTransform: 'uppercase',
                                color: 'var(--muted2)',
                                fontWeight: '600',
                              }}
                            >
                              90d
                            </div>
                            <div
                              style={{
                                fontSize: '12.5px',
                                fontWeight: '600',
                                color: 'var(--pos)',
                                marginTop: '3px',
                                fontVariantNumeric: 'tabular-nums',
                              }}
                            >
                              {dc.t(p?.ret)}
                            </div>
                          </div>{' '}
                          <div
                            style={{
                              border: '1px solid var(--l8)',
                              borderRadius: '11px',
                              padding: '9px 10px',
                            }}
                          >
                            <div
                              style={{
                                fontSize: '9px',
                                letterSpacing: '0.11em',
                                textTransform: 'uppercase',
                                color: 'var(--muted2)',
                                fontWeight: '600',
                              }}
                            >
                              Max DD
                            </div>
                            <div
                              style={{
                                fontSize: '12.5px',
                                fontWeight: '600',
                                color: 'var(--neg)',
                                marginTop: '3px',
                                fontVariantNumeric: 'tabular-nums',
                              }}
                            >
                              {dc.t(p?.dd)}
                            </div>
                          </div>{' '}
                          <div
                            style={{
                              border: '1px solid var(--l8)',
                              borderRadius: '11px',
                              padding: '9px 10px',
                            }}
                          >
                            <div
                              style={{
                                fontSize: '9px',
                                letterSpacing: '0.11em',
                                textTransform: 'uppercase',
                                color: 'var(--muted2)',
                                fontWeight: '600',
                              }}
                            >
                              Win %
                            </div>
                            <div
                              style={{
                                fontSize: '12.5px',
                                fontWeight: '600',
                                marginTop: '3px',
                                fontVariantNumeric: 'tabular-nums',
                              }}
                            >
                              {dc.t(p?.wr)}
                            </div>
                          </div>{' '}
                          <div
                            style={{
                              border: '1px solid var(--l8)',
                              borderRadius: '11px',
                              padding: '9px 10px',
                            }}
                          >
                            <div
                              style={{
                                fontSize: '9px',
                                letterSpacing: '0.11em',
                                textTransform: 'uppercase',
                                color: 'var(--muted2)',
                                fontWeight: '600',
                              }}
                            >
                              PF
                            </div>
                            <div
                              style={{
                                fontSize: '12.5px',
                                fontWeight: '600',
                                marginTop: '3px',
                                fontVariantNumeric: 'tabular-nums',
                              }}
                            >
                              {dc.t(p?.pf)}
                            </div>
                          </div>{' '}
                          <div
                            style={{
                              border: '1px solid var(--l8)',
                              borderRadius: '11px',
                              padding: '9px 10px',
                            }}
                          >
                            <div
                              style={{
                                fontSize: '9px',
                                letterSpacing: '0.11em',
                                textTransform: 'uppercase',
                                color: 'var(--muted2)',
                                fontWeight: '600',
                              }}
                            >
                              Copiers
                            </div>
                            <div
                              style={{
                                fontSize: '12.5px',
                                fontWeight: '600',
                                marginTop: '3px',
                                fontVariantNumeric: 'tabular-nums',
                              }}
                            >
                              {dc.t(p?.followers)}
                            </div>
                          </div>{' '}
                        </div>{' '}
                      </div>{' '}
                    </Fragment>
                  ))}{' '}
                </div>{' '}
              </>
            ) : null}{' '}
            {m.cpIsActive ? (
              <>
                {' '}
                <div>
                  {' '}
                  {m.cpHasActive ? (
                    <>
                      {' '}
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                        {' '}
                        {(m.cpActive ?? []).map((p, i59) => (
                          <Fragment key={i59}>
                            {' '}
                            <div
                              style={{
                                background: 'var(--surface)',
                                border: '1px solid var(--card-line)',
                                boxShadow: 'var(--shadow-card)',
                                borderRadius: '16px',
                                padding: '14px 18px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '16px',
                                flexWrap: 'wrap',
                              }}
                            >
                              {' '}
                              <div style={{ flex: '1', minWidth: '160px' }}>
                                <div style={{ fontSize: '12.5px', fontWeight: '500' }}>{dc.t(p?.name)}</div>
                                <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                                  {dc.t(p?.style)}
                                </div>
                              </div>{' '}
                              <div>
                                <div
                                  style={{
                                    fontSize: '9px',
                                    letterSpacing: '0.11em',
                                    textTransform: 'uppercase',
                                    color: 'var(--muted2)',
                                    fontWeight: '600',
                                  }}
                                >
                                  Allocation
                                </div>
                                <div
                                  style={{
                                    fontSize: '12.5px',
                                    fontWeight: '600',
                                    marginTop: '3px',
                                    fontVariantNumeric: 'tabular-nums',
                                  }}
                                >
                                  {dc.t(p?.alloc)}
                                </div>
                              </div>{' '}
                              <div>
                                <div
                                  style={{
                                    fontSize: '9px',
                                    letterSpacing: '0.11em',
                                    textTransform: 'uppercase',
                                    color: 'var(--muted2)',
                                    fontWeight: '600',
                                  }}
                                >
                                  Live P&L
                                </div>
                                <div
                                  style={{
                                    fontSize: '12.5px',
                                    fontWeight: '600',
                                    color: 'var(--pos)',
                                    marginTop: '3px',
                                    fontVariantNumeric: 'tabular-nums',
                                  }}
                                >
                                  {dc.t(p?.live)}
                                </div>
                              </div>{' '}
                              <button
                                onClick={p?.go}
                                title={`Stop copying ${dc.s(p?.name)}`}
                                aria-label={`Stop copying ${dc.s(p?.name)}`}
                                style={{
                                  fontSize: '11px',
                                  padding: '5px 13px',
                                  borderRadius: '99px',
                                  border: '1px solid color-mix(in srgb, var(--neg) 40%, transparent)',
                                  background: 'transparent',
                                  color: 'var(--neg)',
                                  cursor: 'pointer',
                                }}
                              >
                                Stop copying
                              </button>{' '}
                            </div>{' '}
                          </Fragment>
                        ))}{' '}
                      </div>{' '}
                    </>
                  ) : null}{' '}
                  {m.cpNoActive ? (
                    <>
                      {' '}
                      <div
                        style={{
                          background: 'var(--surface)',
                          border: '1px solid var(--card-line)',
                          boxShadow: 'var(--shadow-card)',
                          borderRadius: '16px',
                          padding: '36px 20px',
                          textAlign: 'center',
                        }}
                      >
                        <i
                          className="ph ph-users-three"
                          style={{ fontSize: '28px', color: 'var(--ghost)' }}
                        ></i>
                        <div style={{ fontSize: '12.5px', color: 'var(--text-mid)', marginTop: '9px' }}>
                          You are not copying anyone yet
                        </div>
                        <div style={{ fontSize: '11px', color: 'var(--faint)', marginTop: '3px' }}>
                          Pick a provider to start mirroring trades.
                        </div>
                      </div>{' '}
                    </>
                  ) : null}{' '}
                </div>{' '}
              </>
            ) : null}{' '}
            {m.cpIsSettings ? (
              <>
                {' '}
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  {' '}
                  <div
                    style={{
                      background: 'var(--surface)',
                      border: '1px solid var(--card-line)',
                      boxShadow: 'var(--shadow-card)',
                      borderRadius: '16px',
                      padding: '16px 18px 14px',
                    }}
                  >
                    {' '}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <span style={{ fontSize: '12.5px', fontWeight: '500', flex: '1' }}>
                        Copy strategy filters
                      </span>
                      <span
                        style={{
                          fontSize: '10.5px',
                          color: 'var(--muted2)',
                          fontVariantNumeric: 'tabular-nums',
                        }}
                      >
                        {dc.t(m.cpStratCount)}
                      </span>
                    </div>{' '}
                    <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                      Copied trades are accepted only when the provider tags them to a strategy you allow —
                      the same playbook you arm in Session Setup.
                    </div>{' '}
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit,minmax(260px,1fr))',
                        gap: '0 18px',
                        marginTop: '10px',
                      }}
                    >
                      {' '}
                      {(m.cpStratFilters ?? []).map((s, i60) => (
                        <Fragment key={i60}>
                          {' '}
                          <button
                            className="scp-4f3e86a"
                            onClick={s?.go}
                            title={dc.a(s?.label)}
                            aria-label={`Toggle copying ${dc.s(s?.label)}`}
                            aria-pressed={dc.b(s?.on)}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '9px',
                              padding: '8px 0',
                              border: 'none',
                              background: 'transparent',
                              textAlign: 'left',
                              cursor: 'pointer',
                              borderRadius: '6px',
                            }}
                          >
                            {' '}
                            <i
                              className={`ph ${dc.s(s?.icon)}`}
                              style={dc.css(`font-size:14px;color:${dc.s(s?.iconFg)};flex:none`)}
                            ></i>{' '}
                            <span style={dc.css(`font-size:11.5px;flex:1;min-width:0;color:${dc.s(s?.fg)}`)}>
                              {dc.t(s?.label)}
                            </span>{' '}
                            <span style={dc.css(`font-size:10px;color:${dc.s(s?.statusFg)}`)}>
                              {dc.t(s?.status)}
                            </span>{' '}
                          </button>{' '}
                        </Fragment>
                      ))}{' '}
                    </div>{' '}
                    {m.cpStratWarn ? (
                      <>
                        {' '}
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '7px',
                            paddingTop: '9px',
                            marginTop: '9px',
                            borderTop: '1px solid var(--l6)',
                            fontSize: '11px',
                            color: 'var(--neg)',
                          }}
                        >
                          <i className="ph ph-warning-circle" style={{ fontSize: '12px' }}></i>No strategies
                          enabled — every copied trade will be rejected.
                        </div>{' '}
                      </>
                    ) : null}{' '}
                  </div>{' '}
                  <div
                    style={{
                      background: 'var(--surface)',
                      border: '1px solid var(--card-line)',
                      boxShadow: 'var(--shadow-card)',
                      borderRadius: '16px',
                      padding: '16px 18px 14px',
                    }}
                  >
                    {' '}
                    <div style={{ fontSize: '12.5px', fontWeight: '500' }}>Risk multiplier</div>{' '}
                    <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                      Scales every copied position against the provider's own size.
                    </div>{' '}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '12px' }}>
                      {' '}
                      <input
                        type="range"
                        min="0.2"
                        max="3"
                        step="0.1"
                        value={dc.v(m.cpMult)}
                        onChange={m.setCpMult}
                        aria-label="Risk multiplier"
                        style={{ flex: '1' }}
                      />{' '}
                      <span
                        style={{
                          fontSize: '13px',
                          fontWeight: '600',
                          fontVariantNumeric: 'tabular-nums',
                          minWidth: '44px',
                          textAlign: 'right',
                        }}
                      >
                        {dc.t(m.cpMultLabel)}
                      </span>{' '}
                    </div>{' '}
                  </div>{' '}
                  <div
                    style={{
                      background: 'var(--surface)',
                      border: '1px solid var(--card-line)',
                      boxShadow: 'var(--shadow-card)',
                      borderRadius: '16px',
                      padding: '16px 18px 14px',
                    }}
                  >
                    {' '}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                      {' '}
                      <div style={{ flex: '1' }}>
                        <div style={{ fontSize: '12.5px', fontWeight: '500' }}>
                          Copy stop loss and take profit
                        </div>
                        <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                          Mirror the provider's protective orders instead of your own defaults.
                        </div>
                      </div>{' '}
                      <Toggle
                        trackBg={m.cpSlTpTrack}
                        knobBg={m.cpSlTpKnobBg}
                        knob={m.cpSlTpKnob}
                        onClick={m.cpSlTpToggle}
                        title="Toggle copying SL and TP"
                        aria-label="Toggle copying stop loss and take profit"
                        aria-pressed={dc.b(m.cpSlTpOn)}
                      />{' '}
                    </div>{' '}
                    <div
                      style={{
                        borderTop: '1px solid var(--l6)',
                        marginTop: '13px',
                        paddingTop: '13px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '14px',
                      }}
                    >
                      {' '}
                      <div style={{ flex: '1' }}>
                        <div style={{ fontSize: '12.5px', fontWeight: '500' }}>Max concurrent copies</div>
                        <div style={{ fontSize: '10.5px', color: 'var(--muted2)', marginTop: '2px' }}>
                          Rejects new copied entries beyond this count.
                        </div>
                      </div>{' '}
                      <input
                        type="number"
                        min="1"
                        max="10"
                        value={dc.v(m.cpMaxCopies)}
                        onChange={m.setCpMaxCopies}
                        aria-label="Maximum concurrent copies"
                        style={{
                          width: '66px',
                          padding: '7px 11px',
                          borderRadius: '9px',
                          border: '1px solid var(--l10)',
                          background: 'var(--fill)',
                          color: 'var(--text)',
                          fontSize: '12px',
                          outline: 'none',
                          fontVariantNumeric: 'tabular-nums',
                        }}
                      />{' '}
                    </div>{' '}
                  </div>{' '}
                  <div
                    style={{
                      background: 'var(--surface)',
                      border: '1px solid var(--card-line)',
                      boxShadow: 'var(--shadow-card)',
                      borderRadius: '16px',
                      padding: '14px 18px',
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: '11px',
                      opacity: '0.75',
                    }}
                  >
                    {' '}
                    <i
                      className="ph ph-lock-simple"
                      style={{ fontSize: '15px', color: 'var(--amb-2)', flex: 'none', marginTop: '1px' }}
                    ></i>{' '}
                    <div style={{ flex: '1' }}>
                      <div style={{ fontSize: '12.5px', fontWeight: '500' }}>Copy to funded accounts</div>
                      <div
                        style={{
                          fontSize: '11px',
                          color: 'var(--muted2)',
                          lineHeight: '1.55',
                          marginTop: '3px',
                        }}
                      >
                        FTMO and FundedNext prohibit copy trading on evaluation and funded accounts, so these
                        targets are locked. Copying runs on Exness #184745 only.
                      </div>
                    </div>{' '}
                    <span
                      style={{
                        fontSize: '9.5px',
                        padding: '2px 9px',
                        borderRadius: '99px',
                        border: '1px solid var(--l10)',
                        color: 'var(--faint)',
                        flex: 'none',
                      }}
                    >
                      Restricted
                    </span>{' '}
                  </div>{' '}
                </div>{' '}
              </>
            ) : null}{' '}
          </div>{' '}
        </>
      ) : null}
    </div>
  );
}
